import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowsRotate } from '@fortawesome/free-solid-svg-icons';
import { useAuth0 } from '@auth0/auth0-react';

Modal.setAppElement('#root');

export const SESSION_OUT_OF_SYNC_EVENT = 'shotkraft:session-out-of-sync';

const SessionOutOfSyncModal = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { logout } = useAuth0();

  useEffect(() => {
    const handleOutOfSync = () => setIsOpen(true);
    window.addEventListener(SESSION_OUT_OF_SYNC_EVENT, handleOutOfSync);
    return () => window.removeEventListener(SESSION_OUT_OF_SYNC_EVENT, handleOutOfSync);
  }, []);

  useEffect(() => {
    if (!isOpen) return;
    const timer = setTimeout(() => {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      logout({ logoutParams: { returnTo: `${window.location.origin}/login` } });
    }, 3000);
    return () => clearTimeout(timer);
  }, [isOpen, logout]);

  return (
    <Modal
      isOpen={isOpen}
      className="modal"
      shouldCloseOnOverlayClick={false}
      shouldCloseOnEsc={false}
    >
      <div style={{ textAlign: 'center', padding: '10px 0 4px' }}>
        <div
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: 60,
            height: 60,
            borderRadius: '50%',
            backgroundColor: 'rgba(122, 100, 235, 0.1)',
            marginBottom: 20,
          }}
        >
          <FontAwesomeIcon icon={faArrowsRotate} style={{ fontSize: 26, color: '#7A64EB' }} />
        </div>

        <div
          className="modalHeader"
          style={{ border: 'none', paddingBottom: 12, fontSize: 20, textAlign: 'center' }}
        >
          We've just shipped an update
        </div>

        <p style={{ color: '#555', fontSize: 15, lineHeight: '22px', margin: '0 0 20px' }}>
          Your browser session is out of sync with the new version. We need to sign you out so
          everything works correctly — your work is saved and you'll be right back in.
        </p>

        <hr style={{ border: 'none', borderTop: '1px solid #eee', margin: '0 0 16px' }} />

        <p style={{ color: '#999', fontSize: 14, marginBottom: 16 }}>Redirecting to sign in…</p>

        <button
          className="buttonClone"
          style={{
            width: '100%',
            padding: '14px',
            borderRadius: 6,
            fontSize: 16,
            cursor: 'default',
            pointerEvents: 'none',
          }}
        >
          Redirecting…
        </button>

        <p style={{ color: '#aaa', fontSize: 13, marginTop: 14, marginBottom: 0 }}>
          This happens when we push new code. It's routine and only takes a moment.
        </p>
      </div>
    </Modal>
  );
};

export default SessionOutOfSyncModal;
